module.exports = __webpack_public_path__ + "static/media/injection-medical-syringe-svgrepo-com.43d1ba42.svg";